import { render, staticRenderFns } from "./ElementAutoConfig.vue?vue&type=template&id=60b749f5&"
import script from "./ElementAutoConfig.vue?vue&type=script&lang=js&"
export * from "./ElementAutoConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b749f5')) {
      api.createRecord('60b749f5', component.options)
    } else {
      api.reload('60b749f5', component.options)
    }
    module.hot.accept("./ElementAutoConfig.vue?vue&type=template&id=60b749f5&", function () {
      api.rerender('60b749f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/ElementAutoConfig.vue"
export default component.exports